import React from 'react';
import { useSearchAdContext } from './SearchAdContext';

type SearchAdLinkProps = {
    ariaHidden?: boolean;
    children?: React.ReactNode;
    className?: string;
    id?: string;
    tabIndex?: number;
};

export function SearchAdLink(props: SearchAdLinkProps) {
    const { ariaHidden, children, className = '', id, tabIndex } = props;

    const { onClick, target, url } = useSearchAdContext();

    // Trigger onClick handler specifically on middle mouse button (or command)
    // click. This is important for tracking, since tracking events would
    // otherwise not be triggered on these click events.
    const onAuxClick = React.useMemo(() => {
        return onClick
            ? (ev: React.MouseEvent) => {
                  if (ev.button === 1) {
                      onClick(ev);
                  }
              }
            : void 0;
    }, [onClick]);

    return (
        <a
            aria-hidden={ariaHidden}
            className={`sf-search-ad-link ${className}`}
            href={url}
            id={id}
            onAuxClick={onAuxClick}
            onClick={onClick}
            rel={target === '_blank' ? 'noreferrer' : undefined}
            tabIndex={tabIndex}
            target={target}
        >
            <span className="absolute inset-0" aria-hidden="true"></span>
            {children}
        </a>
    );
}
